(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", async () => {
    const root = document.querySelector(".booking-widget--clinic");
    if (!root) return;

    if (document.body.classList.contains("template-cart")) return;

    if (!window.flatpickr) {
      console.error("Clinic widget: flatpickr not loaded");
      return;
    }

    const apiBase = (root.dataset.apiBase || "/a/booking").replace(/\/$/, "");
    const clinicVariantId = String(root.dataset.variantId || "").trim();
    const clinicClosureDays = String(root.dataset.closureDays || "14").trim();

    const elSlots = root.querySelector("#bw-slots-list");
    const hintDate = root.querySelector("#bw-date-hint");
    const hintTime = root.querySelector("#bw-time-hint");
    const hintSubmit = root.querySelector("#bw-submit-hint");
    const btnContinue = root.querySelector("#bw-continue");

    const hiddenPractitioner = root.querySelector("#bw_practitioner_id");
    const hiddenStart = root.querySelector("#bw_start");
    const hiddenEnd = root.querySelector("#bw_end");

    const dateInput = root.querySelector("#bw-date");
    const calendarMount = root.querySelector("#bw-calendar-inline");

    const phoneModal = root.querySelector("#bw-phone-modal");
    const phoneInput = root.querySelector("#bw-phone-input");
    const phoneSaveBtn = root.querySelector("#bw-phone-save");
    const phoneError = root.querySelector("#bw-phone-error");
    const clinicClosuresPanels = Array.from(document.querySelectorAll("[data-clinic-closures]"));

    if (
      !clinicVariantId || !elSlots || !btnContinue ||
      !hiddenPractitioner || !hiddenStart || !hiddenEnd ||
      !dateInput || !calendarMount
    ) {
      console.error("Clinic widget: missing DOM nodes or data-variant-id");
      return;
    }

    if (phoneModal && phoneModal.parentElement !== document.body) {
      document.body.appendChild(phoneModal);
    }

    let locationId = String(root.dataset.locationId || "").trim();
    const slotCache = new Map();
    let reserveInFlight = false;

    /* ---------------- helpers ---------------- */

    function ymd(d) {
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    }

    function pad(n) { return String(n).padStart(2, "0"); }

function formatTimeRange(startIso, endIso) {
  return formatTimeRangeFromIsoStrings(startIso, endIso);
}

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }


    function buildUrl(path, params) {
      const qs = new URLSearchParams(params);
      const joiner = apiBase.includes("?") ? "&" : "?";
      return `${apiBase}${path}${joiner}${qs.toString()}`;
    }

    
    async function fetchJson(url) {
      const res = await fetch(url, {
        method: "GET", credentials: "same-origin",
        cache: "no-store", headers: { Accept: "application/json" },
      });
      const text = await res.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch (_) {}
      if (!res.ok) throw new Error(data?.error || text || `HTTP ${res.status}`);
      return data;
    }

    async function postJson(url, payload) {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin", cache: "no-store",
      });
      const text = await res.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch (_) {}
      if (!res.ok) throw new Error(data?.error || text || "Request failed");
      return data;
    }

    async function updateCartAttributes(attrs) {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attrs }),
        credentials: "same-origin",
      });
      if (!res.ok) throw new Error("Failed to update cart attributes");
      return res.json();
    }

    async function refreshCartBubble() {
      try {
        const cart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
        const count = Number(cart?.item_count || 0);
        const countStr = count > 0 ? String(count) : "";
        document.querySelectorAll("[data-header-cart-count]").forEach(n => {
          try {
            n.setAttribute("data-header-cart-count", countStr);
            n.classList.toggle("visible", count > 0);
          } catch (_) {}
        });
        document.querySelectorAll(
          "[data-cart-count], .cart-count-bubble span[aria-hidden=\"true\"], .cart-count, #cart-icon-bubble .cart-count-bubble span"
        ).forEach(n => { try { n.textContent = countStr; } catch (_) {} });
      } catch (_) {}
    }

    async function addVariantToCart(shopifyVariantId, properties) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: Number(shopifyVariantId), quantity: 1, properties }),
      });
      const text = await res.text();
      let data = {};
      try { data = text ? JSON.parse(text) : {}; } catch (_) {}
      if (!res.ok) throw new Error(data?.description || data?.message || text || "Failed to add clinic product");
      try { document.dispatchEvent(new CustomEvent("cart:item-added")); } catch (_) {}
      // Not waited on: the booking goes on to the basket page, which shows its own count.
      refreshCartBubble().catch(() => {});
      return data;
    }

    function disableBtn(msg = "") {
      btnContinue.disabled = true;
      btnContinue.setAttribute("disabled", "disabled");
      if (hintSubmit) hintSubmit.textContent = msg;
    }

    function enableBtn(msg = "") {
      btnContinue.disabled = false;
      btnContinue.removeAttribute("disabled");
      if (hintSubmit) hintSubmit.textContent = msg;
    }

    function clearSelection() {
      hiddenPractitioner.value = "";
      hiddenStart.value = "";
      hiddenEnd.value = "";
      disableBtn("");
      if (hintTime) hintTime.textContent = "";
    }

    /* ---------------- phone helpers ---------------- */

    function normalizePhone(raw) { return String(raw || "").trim(); }

    function isValidPhone(raw) {
      if (window.BookingPhone) return window.BookingPhone.validPhone(raw);
      const p = normalizePhone(raw);
      if (!p) return false;
      const digits = p.replace(/[^\d]/g, "");
      return digits.length >= 9 && digits.length <= 16;
    }

    function getCachedPhone() {
      try { return localStorage.getItem("bw_phone_number") || ""; } catch (_) { return ""; }
    }

    function setCachedPhone(v) {
      try { localStorage.setItem("bw_phone_number", v); } catch (_) {}
    }

    function openPhoneModal(prefill = "") {
      if (!phoneModal || !phoneInput) return false;
      if (phoneError) phoneError.textContent = "";
      phoneInput.value = prefill || "";
      if (phoneUi) phoneUi.prepare(prefill);
      phoneModal.classList.remove("is-hidden");
      phoneModal.setAttribute("aria-hidden", "false");
      setTimeout(() => (phoneUi ? phoneUi.focus() : phoneInput.focus()), 0);
      return true;
    }

    function closePhoneModal() {
      if (!phoneModal) return;
      phoneModal.classList.add("is-hidden");
      phoneModal.setAttribute("aria-hidden", "true");
    }

    if (phoneModal) {
      phoneModal.addEventListener("click", (e) => {
        if (e.target && e.target.matches("[data-bw-close]")) closePhoneModal();
      });
    }

    // Views, the skip and the events of the shared phone pop-up (assets/booking-phone.js).
    let phoneSkipped = false;   // Skip: not asked again on this page
    let rememberedPending = false;
    let flowPhone = "";         // the number given in this page view, in case it can't be remembered in the browser
    const phoneUi = window.BookingPhone
      ? window.BookingPhone.attach(phoneModal, { cal: "clinic", onSkip: skipPhone })
      : null;
    // Phone only when there is a number: the portal takes any value there as the number.
    const phoneLineProps = (phone) =>
      window.BookingPhone ? window.BookingPhone.phoneLineProps(phone) : { Phone: String(phone || "") };
    const phoneCartAttrs = (phone) =>
      window.BookingPhone
        ? window.BookingPhone.phoneCartAttrs(phone)
        : { booking_phone_number: String(phone || ""), booking_phone_status: phone ? "given" : "declined" };

    // The grey "Reserving your slot…" screen (assets/booking-busy.js): up from the moment a booking starts until
    // the basket opens, down before any error shows. Never in the way of a booking when the script is missing.
    const busy = (fn, text) => {
      try { if (window.BookingBusy) window.BookingBusy[fn](text); } catch (_) { /* the booking matters more */ }
    };

    // Skip and Continue write nothing on their own: the booking's attribute write carries the number and its
    // status (makeCartAttrs), one request instead of two.
    async function skipPhone() {
      if (phoneUi) phoneUi.skipped();
      phoneSkipped = true;
      closePhoneModal();
      await continueConfirmFlow();
    }

    /* ---------------- booking payload ---------------- */

function formatDateGB(isoStr) {
  return formatDateGBFromIsoString(isoStr);
}

    /**
     * Line item properties — sent to /cart/add.js.
     * Shopify hides any property whose name starts with '_', so:
     *   visible: Date, Time, Phone  (human-readable for the customer)
     *   hidden:  _booking_* fields  (internal, used by the backend webhook)
     */
    function makeLineItemProps({ hold, phone }) {
      return {
        Date:  formatDateGB(hiddenStart.value),
        Time:  formatTimeRange(hiddenStart.value, hiddenEnd.value),
        ...phoneLineProps(phone),
        _booking_location_id:            String(locationId || ""),
        _booking_practitioner_id:        String(hiddenPractitioner.value || ""),
        _booking_start:                  String(hiddenStart.value || ""),
        _booking_end:                    String(hiddenEnd.value || ""),
        _booking_reserved:               "true",
        _booking_reservation_id:         String(hold?.reservation_id || ""),
        _booking_reservation_expires_at: String(hold?.expires_at || ""),
      };
    }

    /**
     * Cart note_attributes — sent to /cart/update.js.
     * No underscore needed here (not shown on checkout); backend reads these
     * without underscore prefix via _note_attrs().
     */
    function makeCartAttrs({ hold, phone }) {
      return {
        booking_location_id:            String(locationId || ""),
        booking_practitioner_id:        String(hiddenPractitioner.value || ""),
        booking_start:                  String(hiddenStart.value || ""),
        booking_end:                    String(hiddenEnd.value || ""),
        ...phoneCartAttrs(phone),
        booking_reserved:               "true",
        booking_reservation_id:         String(hold?.reservation_id || ""),
        booking_reservation_expires_at: String(hold?.expires_at || ""),
      };
    }

    // Keep old name as alias so any external callers aren't broken
    function makeBookingPayload(args) { return makeCartAttrs(args); }

    /* ---------------- API steps ---------------- */

    async function resolveLocationIdIfNeeded() {
      if (locationId) return;
      const loc = await fetchJson(
        buildUrl("/public/location_for_variant/", { variant_id: clinicVariantId })
      );
      locationId = String(loc?.location_id || "").trim();
      if (locationId) root.dataset.locationId = locationId;
    }

    async function loadEnabledDays(instance) {
      const start = new Date(instance.currentYear, instance.currentMonth, 1);
      const end = new Date(instance.currentYear, instance.currentMonth + 1, 1);
      if (hintDate) hintDate.textContent = "Loading availability…";
      const data = await fetchJson(
        buildUrl("/public/days/", { location_id: locationId, start: ymd(start), end: ymd(end) })
      );
      const list = Array.isArray(data?.enabled_days) ? data.enabled_days : [];
      instance.set("enable", list);
      if (hintDate) hintDate.textContent = "Pick a date to see available slots.";
    }

    async function getSlots(dateStr) {
      if (!dateStr) return [];
      if (slotCache.has(dateStr)) return slotCache.get(dateStr);
      const data = await fetchJson(
        buildUrl("/public/slots/", { location_id: locationId, date: dateStr })
      );
      const slots = Array.isArray(data?.slots) ? data.slots : [];
      slotCache.set(dateStr, slots);
      return slots;
    }

    /* ---------------- GP-style AM/PM slot rendering ---------------- */

    function parseIsoParts(iso) {
  const m = String(iso || "").match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?([+-]\d{2}:\d{2}|Z)?$/
  );

  if (!m) {
    return null;
  }

  return {
    year: m[1],
    month: m[2],
    day: m[3],
    hour: m[4],
    minute: m[5],
    second: m[6] || "00",
    offset: m[7] || "",
  };
}

function formatTimeHMFromIsoString(iso) {
  const p = parseIsoParts(iso);
  if (!p) return "";
  return `${p.hour}:${p.minute}`;
}

function formatTimeRangeFromIsoStrings(startIso, endIso) {
  const s = parseIsoParts(startIso);
  const e = parseIsoParts(endIso);
  if (!s || !e) return "";
  return `${s.hour}:${s.minute} - ${e.hour}:${e.minute}`;
}

function formatDateGBFromIsoString(iso) {
  const p = parseIsoParts(iso);
  if (!p) return "";

  const utcDate = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day)));
  return utcDate.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

function durationMinutesFromIsoStrings(startIso, endIso) {
  const startMs = Date.parse(startIso);
  const endMs = Date.parse(endIso);

  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
    return "";
  }

  return String(Math.max(0, Math.round((endMs - startMs) / 60000)));
}

function minutesFromIso(iso) {
  const p = parseIsoParts(iso);
  if (!p) return 0;
  return Number(p.hour) * 60 + Number(p.minute);
}

    /* ---------------- clinic closure notices ---------------- */

    function parseYmd(ymdStr) {
      const m = String(ymdStr || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return null;
      return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    }

    function ordinalSuffix(day) {
      return day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";
    }

    function formatClosureDateSet(ymdStr) {
      const d = parseYmd(ymdStr);
      if (!d) return { full: "", compact: "", short: "" };
      const day = Number(ymdStr.slice(8, 10));
      const fullWeekday = d.toLocaleDateString("en-GB", {
        weekday: "long",
        timeZone: "UTC",
      });
      const shortWeekday = d.toLocaleDateString("en-GB", {
        weekday: "short",
        timeZone: "UTC",
      });
      const month = d.toLocaleDateString("en-GB", {
        month: "long",
        timeZone: "UTC",
      });
      const shortMonth = d.toLocaleDateString("en-GB", {
        month: "short",
        timeZone: "UTC",
      });
      const suffix = ordinalSuffix(day);

      return {
        full: `${fullWeekday} the ${day}${suffix} of ${month}`,
        compact: `${shortWeekday} ${day}${suffix} ${shortMonth}`,
        short: `${shortWeekday} ${day} ${shortMonth}`,
      };
    }

    function formatClosureRangeSet(startYmd, endYmd) {
      const start = formatClosureDateSet(startYmd);
      const end = formatClosureDateSet(endYmd);
      if (!start.full) return { full: "", compact: "", short: "" };
      if (!end.full || startYmd === endYmd) return start;
      return {
        full: `${start.full} - ${end.full}`,
        compact: `${start.compact} - ${end.compact}`,
        short: `${start.short} - ${end.short}`,
      };
    }

    function scheduleChangeText(change) {
      const detail = String(change?.detail || "").trim();
      switch (change?.kind) {
        case "closed":
          return {
            full: detail ? `The clinic will be closed ${detail}` : "The clinic will be closed",
            compact: detail ? `Closed ${detail}` : "Closed",
            short: "Closed",
          };
        case "late_opening":
          return {
            full: detail ? `The clinic will open late from ${detail}` : "The clinic will open late",
            compact: detail ? `Opens late ${detail}` : "Opens late",
            short: detail ? `Late ${detail}` : "Late opening",
          };
        case "early_closure":
          return {
            full: detail ? `The clinic will close early at ${detail}` : "The clinic will close early",
            compact: detail ? `Closes early ${detail}` : "Closes early",
            short: detail ? `Early ${detail}` : "Early closure",
          };
        case "partial":
          return {
            full: detail ? `The clinic will have reduced hours: ${detail}` : "The clinic will have reduced hours",
            compact: detail ? `Reduced hours ${detail}` : "Reduced hours",
            short: detail ? `Hours ${detail}` : "Reduced hours",
          };
        default:
          return {
            full: detail ? `There will be an opening times change: ${detail}` : "There will be an opening times change",
            compact: detail ? `Opening times change: ${detail}` : "Opening times change",
            short: "Opening times",
          };
      }
    }

    function buildClosureItems(data) {
      const items = [];

      (Array.isArray(data?.closures) ? data.closures : []).forEach((closure) => {
        const startDate = closure?.start_date || "";
        const endDate = closure?.end_date || startDate;
        const reason = String(closure?.reason || "").trim();
        items.push({
          sortDate: startDate,
          dateLabel: formatClosureRangeSet(startDate, endDate),
          title: {
            full: reason ? `The clinic will be closed ${reason}` : "The clinic will be closed",
            compact: reason ? `Closed ${reason}` : "Closed",
            short: "Closed",
          },
        });
      });

      (Array.isArray(data?.schedule_changes) ? data.schedule_changes : []).forEach((change) => {
        const text = scheduleChangeText(change);
        items.push({
          sortDate: change?.date || "",
          dateLabel: formatClosureDateSet(change?.date),
          title: text,
        });
      });

      return items
        .filter((item) => item.dateLabel?.full && item.title?.full)
        .sort((a, b) => String(a.sortDate).localeCompare(String(b.sortDate)));
    }

    function removeManualClinicClosureNotices() {
      const manualNoticePattern = /(?:please note that\s+)?the clinic will\s+(?:be\s+)?(?:closed|close|open late)/i;

      // All wrappers: a manual note can sit in a block that has no panel.
      document.querySelectorAll(".key-details .key-details__wrapper").forEach((wrapper) => {
        Array.from(wrapper.querySelectorAll("p")).forEach((paragraph) => {
          const text = String(paragraph.textContent || "").replace(/\s+/g, " ").trim();
          if (manualNoticePattern.test(text)) {
            paragraph.remove();
          }
        });
      });
    }

    function renderClinicClosures(data) {
      if (!clinicClosuresPanels.length) return;

      removeManualClinicClosureNotices();
      const items = buildClosureItems(data);
      if (!items.length) {
        clinicClosuresPanels.forEach((panel) => {
          const list = panel.querySelector("[data-clinic-closures-list]");
          panel.classList.add("is-hidden");
          if (list) list.innerHTML = "";
        });
        return;
      }

      const visibleLimit = 5;
      const hiddenCount = Math.max(0, items.length - visibleLimit);
      const html = items.map((item, idx) => `
        <div class="bw-clinic-update${idx >= visibleLimit ? " is-hidden" : ""}" data-clinic-update-item>
          <div class="bw-clinic-update__date">
            <span class="bw-copy bw-copy--full">${escapeHtml(item.dateLabel.full)}</span>
            <span class="bw-copy bw-copy--compact">${escapeHtml(item.dateLabel.compact)}</span>
            <span class="bw-copy bw-copy--short">${escapeHtml(item.dateLabel.short)}</span>
          </div>
          <div class="bw-clinic-update__content">
            <div class="bw-clinic-update__title">
              <span class="bw-copy bw-copy--full">${escapeHtml(item.title.full)}</span>
              <span class="bw-copy bw-copy--compact">${escapeHtml(item.title.compact)}</span>
              <span class="bw-copy bw-copy--short">${escapeHtml(item.title.short)}</span>
            </div>
          </div>
        </div>
      `).join("") + (hiddenCount ? `
        <button type="button" class="bw-clinic-updates__show-more" data-clinic-closures-show-more>
          Show later dates
        </button>
      ` : "");

      clinicClosuresPanels.forEach((panel) => {
        const list = panel.querySelector("[data-clinic-closures-list]");
        if (!list) return;
        list.innerHTML = html;
        panel.classList.remove("is-hidden");

        const showMore = list.querySelector("[data-clinic-closures-show-more]");
        if (showMore) {
          showMore.addEventListener("click", () => {
            const isExpanded = showMore.getAttribute("aria-expanded") === "true";
            list.querySelectorAll("[data-clinic-update-item]").forEach((row, idx) => {
              row.classList.toggle("is-hidden", isExpanded && idx >= visibleLimit);
            });
            showMore.setAttribute("aria-expanded", isExpanded ? "false" : "true");
            showMore.textContent = isExpanded ? "Show later dates" : "Hide later dates";
          });
        }
      });
    }

    async function loadClinicClosures() {
      if (!clinicVariantId || !clinicClosuresPanels.length) return;

      removeManualClinicClosureNotices();

      const params = { variant_id: clinicVariantId };
      if (clinicClosureDays) params.days = clinicClosureDays;

      try {
        const data = await fetchJson(buildUrl("/public/clinic-closures/", params));
        renderClinicClosures(data);
      } catch (e) {
        console.warn("Clinic widget: failed to load schedule changes", e);
        clinicClosuresPanels.forEach((panel) => {
          const list = panel.querySelector("[data-clinic-closures-list]");
          panel.classList.add("is-hidden");
          if (list) list.innerHTML = "";
        });
      }
    }

    function renderSlots(slots) {
      clearSelection();

      if (!slots.length) {
        elSlots.innerHTML = `<div class="bw-empty">No available slots for this date.</div>`;
        return;
      }

      const sorted = [...slots].sort((a, b) => minutesFromIso(a.start) - minutesFromIso(b.start));
      const am = [];
      const pm = [];

      sorted.forEach((s, idx) => {
        (minutesFromIso(s.start) < 720 ? am : pm).push({ slot: s, idx });
      });

      const renderGroup = (title, period, items) => {
        const empty = `<div class="booking-slots__empty">No ${title} slots</div>`;
        const buttons = items.length
          ? items.map(({ slot, idx }) => `
              <button type="button" class="bw-slot" data-idx="${idx}" data-period="${period}">
                <span class="bw-slot__time">${escapeHtml(formatTimeHMFromIsoString(slot.start))}</span>
              </button>
            `).join("")
          : empty;

        return `
          <section class="bw-slot-group bw-slot-group--${period}" data-period="${period}">
            <div class="bw-slot-group__header">
              <div class="bw-slot-group__title">${title}</div>
            </div>
            <div class="bw-slot-grid">${buttons}</div>
          </section>
        `;
      };

      elSlots.innerHTML = `
        <div class="bw-ampm-toggle" role="tablist" aria-label="Choose AM or PM">
          <button type="button" class="bw-ampm-btn is-active" data-show="am">Morning</button>
          <button type="button" class="bw-ampm-btn" data-show="pm">Afternoon</button>
        </div>
        <div class="bw-slot-groups">
          ${renderGroup("Morning (AM)", "am", am)}
          ${renderGroup("Afternoon (PM)", "pm", pm)}
        </div>
      `;

      const applyMobileMode = () => {
        const isMobile = window.matchMedia("(max-width: 460px)").matches;
        if (!isMobile) {
          elSlots.querySelectorAll(".bw-slot-group").forEach((g) => g.classList.remove("is-hidden"));
          return;
        }
        const activeBtn = elSlots.querySelector(".bw-ampm-btn.is-active");
        const currentPeriod = activeBtn ? activeBtn.dataset.show : "am";
        elSlots.querySelectorAll(".bw-slot-group").forEach((g) => {
          g.classList.toggle("is-hidden", g.dataset.period !== currentPeriod);
        });
      };

      applyMobileMode();
      window.addEventListener("resize", applyMobileMode);

      elSlots.onclick = (e) => {
        // AM/PM toggle
        const toggleBtn = e.target.closest(".bw-ampm-btn");
        if (toggleBtn) {
          e.preventDefault();
          const showPeriod = toggleBtn.dataset.show;
          elSlots.querySelectorAll(".bw-ampm-btn").forEach((b) => b.classList.remove("is-active"));
          toggleBtn.classList.add("is-active");
          elSlots.querySelectorAll(".bw-slot-group").forEach((g) => {
            g.classList.toggle("is-hidden", g.dataset.period !== showPeriod);
          });
          toggleBtn.scrollIntoView({ behavior: "instant", block: "nearest" });
          return;
        }

        // Slot selection
        const b = e.target.closest(".bw-slot");
        if (!b) return;

        elSlots.querySelectorAll(".bw-slot").forEach((x) => x.classList.remove("is-selected"));
        b.classList.add("is-selected");

        const slot = sorted[Number(b.dataset.idx)];
        if (!slot) return;

        // practitioner_id may be present in full-mode responses; falls back to empty
        hiddenPractitioner.value = String(slot.practitioner_id || "");
        hiddenStart.value = slot.start;
        hiddenEnd.value = slot.end;

        enableBtn("Ready — click to add to basket & reserve for 20 minutes.");
        if (hintTime) hintTime.textContent = "Selected.";
      };
    }

    /* ---------------- boot ---------------- */

    clearSelection();
    elSlots.innerHTML = `<div class="bw-empty">SELECT A DATE FIRST</div>`;
    loadClinicClosures();

    try {
      await resolveLocationIdIfNeeded();
    } catch (e) {
      console.error(e);
      elSlots.innerHTML = `<div class="bw-empty">Could not resolve clinic for this product.</div>`;
      return;
    }

    if (!locationId) {
      elSlots.innerHTML = `<div class="bw-empty">Clinic not found for this product.</div>`;
      return;
    }

    window.flatpickr(dateInput, {
      inline: true,
      appendTo: calendarMount,
      dateFormat: "Y-m-d",
      disableMobile: true,
      minDate: "today",
      enable: [],
      fixedHeight: false,
      showMonths: 1,
      locale: { firstDayOfWeek: 1 },

      onReady: async (_d, _s, instance) => {
        try { await loadEnabledDays(instance); }
        catch (e) {
          console.error(e);
          if (hintDate) hintDate.textContent = "Failed to load availability.";
        }
      },

      onMonthChange: async (_d, _s, instance) => {
        slotCache.clear();
        clearSelection();
        elSlots.innerHTML = `<div class="bw-empty">SELECT A DATE FIRST</div>`;
        try { await loadEnabledDays(instance); }
        catch (e) {
          console.error(e);
          if (hintDate) hintDate.textContent = "Failed to load availability.";
        }
      },

      onYearChange: async (_d, _s, instance) => {
        slotCache.clear();
        clearSelection();
        elSlots.innerHTML = `<div class="bw-empty">SELECT A DATE FIRST</div>`;
        try { await loadEnabledDays(instance); }
        catch (e) {
          console.error(e);
          if (hintDate) hintDate.textContent = "Failed to load availability.";
        }
      },

      onChange: async (_d, dateStr) => {
        clearSelection();
        if (!dateStr) return;
        elSlots.innerHTML = `<div class="bw-loading">Loading slots…</div>`;
        try {
          const slots = await getSlots(dateStr);
          renderSlots(slots);
        } catch (e) {
          console.error(e);
          elSlots.innerHTML = `<div class="bw-empty">Failed to load slots.</div>`;
        }
      },
    });

    /* ---------------- confirm flow ---------------- */

    async function continueConfirmFlow() {
      if (reserveInFlight) return;

      if (!hiddenStart.value) {
        disableBtn("Select date and time first.");
        return;
      }

      const cartHoldId = window?.__booking_cart_hold_id || null;
      const cartHoldExp = window?.__booking_cart_hold_exp || null;
      if (cartHoldId && cartHoldExp && new Date(cartHoldExp) > new Date()) {
        window.location.assign("/cart");
        return;
      }

      // A valid remembered number is the latest word (it may have been changed in the basket since).
      const cachedNow = normalizePhone(getCachedPhone());
      const phone = isValidPhone(cachedNow) ? cachedNow : phoneSkipped ? "" : normalizePhone(flowPhone);

      reserveInFlight = true;
      if (rememberedPending && phoneUi) phoneUi.remembered();
      rememberedPending = false;
      disableBtn("Reserving…");
      btnContinue.style.pointerEvents = "none";
      busy("show", window.BookingBusy && window.BookingBusy.RESERVING);
      // How long each step takes, in the console, to compare on a phone ("[booking] timing").
      const t0 = Date.now();
      const timing = (step) => { try { console.info("[booking] timing", step, Date.now() - t0 + "ms"); } catch (_) {} };

      try {
        const confirmPayload = {
          location_id: Number(locationId),
          start: hiddenStart.value,
          notes: "",
        };
        if (hiddenPractitioner.value) {
          confirmPayload.practitioner_id = Number(hiddenPractitioner.value);
        }

        const hold = await postJson(buildUrl("/public/confirm/", {}), confirmPayload);
        timing("reserved");
        const lineItemProps = makeLineItemProps({ hold, phone });
        const cartAttrs    = makeCartAttrs({ hold, phone });

        await addVariantToCart(clinicVariantId, lineItemProps);
        timing("appointment added");
        await updateCartAttributes(cartAttrs);
        timing("details saved");
        window.__booking_cart_hold_id  = cartAttrs.booking_reservation_id;
        window.__booking_cart_hold_exp = cartAttrs.booking_reservation_expires_at;


if (hold.reservation_id && hold.expires_at && window.BookingHoldTimer) {
  window.BookingHoldTimer.startHold(hold.reservation_id, hold.expires_at, clinicVariantId);
}

        if (hintSubmit) hintSubmit.textContent = "Added to basket. Redirecting…";
        window.location.assign("/cart");
      } catch (err) {
        console.error(err);
        busy("hide");
        btnContinue.style.pointerEvents = "auto";
        enableBtn(err?.message || "Could not book appointment. Try again.");
      } finally {
        reserveInFlight = false;
      }
    }

    if (phoneSaveBtn) {
      phoneSaveBtn.addEventListener("click", async () => {
        const raw = phoneInput ? phoneInput.value : "";
        if (!isValidPhone(raw)) {
          if (phoneError) phoneError.textContent = "Please enter a valid phone number.";
          return;
        }
        const phone = normalizePhone(raw);
        try {
          setCachedPhone(phone);
          flowPhone = phone;
          if (phoneUi) phoneUi.given(phone);
          closePhoneModal();
          await continueConfirmFlow();
        } catch (err) {
          console.error(err);
          if (phoneError) phoneError.textContent = "Could not save phone number. Please try again.";
        }
      });
    }

    /* ---------- existing slot detection ---------- */

    const existingSlotPanel = root.querySelector("#bw-existing-slot");
    const existingSlotBody  = root.querySelector(".bw-existing-slot__body");
    const existingSlotX     = root.querySelector("#bw-existing-slot-x");
    const bookingLayout     = root.querySelector("#bw-booking-layout");

    let existingCartItem = null; // { key, title, start, end, locationName }

    /**
     * Shopify variant IDs of the phlebotomy clinic products, from the same
     * /public/locations/ list the inline widget uses.  GP consultations come from
     * /public/gp/locations/ and so are never in this set — which is how we tell a
     * clinic appointment apart from other bookings sharing the cart.
     * Resolves to an empty set if the call fails; detection then falls back to the
     * reserved flag alone.
     */
    async function loadClinicVariantIds() {
      try {
        const locs = await fetchJson(buildUrl("/public/locations/", {}));
        const ids = new Set();
        for (const loc of Array.isArray(locs) ? locs : []) {
          // /public/locations/ also returns the "Online …" consultation locations
          // (GP, TRT, weight loss …).  Drop them the same way the inline widget
          // does, so a GP appointment is never mistaken for a clinic slot.
          if (/^online\b/i.test(String(loc?.name || "").trim())) continue;

          const vid =
            loc?.shopify_variant_id ||
            Object.values(loc?.booking_variants || {})
              .map((entry) => entry?.shopify_variant_id)
              .find(Boolean) ||
            loc?.variant_id;
          if (vid) ids.add(String(vid));
        }
        return ids;
      } catch (_) {
        return new Set();
      }
    }

    function detectExistingSlotInCart(cart, clinicVariantIds) {
      if (!cart?.items) return null;
      const attrs = cart.attributes || {};

      for (const item of cart.items) {
        const p = item.properties || {};

        // Written only by the GP widget — never a phlebotomy clinic appointment.
        if (p._booking_consultation_variant_id || p.booking_consultation_variant_id) continue;

        // Booked from a clinic product page — this widget wrote the flag itself.
        const reserved = p._booking_reserved || p.booking_reserved || "";
        const bookedHere = reserved === "true" || reserved === "cart_only";

        // Booked from an inline (test product) calendar: no flag, but the line
        // carries the _booking_* slot properties on a known clinic variant.
        const hasSlotProps = !!(
          p._booking_start || p.booking_start ||
          p._booking_reservation_id || p.booking_reservation_id
        );
        const isClinicVariant = !!clinicVariantIds?.has(String(item.variant_id || ""));

        if (!bookedHere && !(hasSlotProps && isClinicVariant)) continue;

        return {
          key: item.key,
          title: p.Clinic || p.clinic || item.product_title || item.title || "Clinic appointment",
          locationName: p._booking_location_id || p.booking_location_id || item.title || "Clinic",
          start: p._booking_start || p.booking_start || attrs.booking_start || "",
          end:   p._booking_end   || p.booking_end   || attrs.booking_end   || "",
        };
      }
      return null;
    }

function showExistingSlot(item) {
  if (!existingSlotPanel || !existingSlotBody) return;

  const dateLabel = item.start ? formatDateGBFromIsoString(item.start) : "";
  const timeLabel = item.start && item.end
    ? formatTimeRangeFromIsoStrings(item.start, item.end)
    : "";

  const slotLine = dateLabel
    ? `${escapeHtml(dateLabel)}${timeLabel ? ", " + escapeHtml(timeLabel) : ""} (<a href="#" class="bw-rebook-link">change</a>)`
    : `<a href="#" class="bw-rebook-link">Change appointment</a>`;

  existingSlotBody.innerHTML =
    `<strong>✓ Slot reserved</strong><br>` +
    `<span>${escapeHtml(item.title)}</span><br>` +
    `<span>${slotLine}</span>`;

  const rebookLink = existingSlotBody.querySelector(".bw-rebook-link");
  if (rebookLink) {
    rebookLink.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      doRebook();
    });
  }

  existingSlotPanel.classList.remove("is-hidden");
  if (bookingLayout) bookingLayout.classList.add("is-hidden");
}
    function hideExistingSlot() {
      if (existingSlotPanel) existingSlotPanel.classList.add("is-hidden");
      if (bookingLayout) bookingLayout.classList.remove("is-hidden");
    }

    async function doRebook() {
      if (existingCartItem?.key) {
        try {
          await fetch("/cart/change.js", {
            method: "POST", credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: existingCartItem.key, quantity: 0 }),
          });
        } catch (_) {}
        await refreshCartBubble().catch(() => {});
      }
      existingCartItem = null;
      hideExistingSlot();
    }

    if (existingSlotX) {
      existingSlotX.addEventListener("click", (e) => { e.stopPropagation(); doRebook(); });
      existingSlotX.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); doRebook(); }
      });
    }

    // Check cart on load
    try {
      const [cart, clinicVariantIds] = await Promise.all([
        fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json()),
        loadClinicVariantIds(),
      ]);
      existingCartItem = detectExistingSlotInCart(cart, clinicVariantIds);
      if (existingCartItem) showExistingSlot(existingCartItem);
    } catch (_) {}

    /* ---------- confirm button ---------- */

    btnContinue.addEventListener("click", async (e) => {
      e.preventDefault();

      if (!hiddenStart.value) {
        disableBtn("Select date and time first.");
        return;
      }

      // A slot already held in the basket only sends them to the basket: no need to ask.
      const cartHoldExp = window?.__booking_cart_hold_exp || null;
      if (window?.__booking_cart_hold_id && cartHoldExp && new Date(cartHoldExp) > new Date()) {
        await continueConfirmFlow();
        return;
      }

      // Asked only without a remembered number, as on the other calendars; a remembered one goes straight
      // through and can be changed in the basket. An answer already given here (a number or Skip) stands.
      const cached = getCachedPhone();
      if (!isValidPhone(cached) && (phoneSkipped || flowPhone)) {
        await continueConfirmFlow();
        return;
      }
      if (isValidPhone(cached)) {
        rememberedPending = true;
        await continueConfirmFlow();
        return;
      }

      if (!openPhoneModal(cached)) {
        // No modal in the DOM — fall through as the widget did before, rather than
        // leaving the button doing nothing.
        await continueConfirmFlow();
      }
    });
  });
})();
